import { createGetApiHook, createPostApiHook } from "./apiHooks";
import { APIResponseType } from "../../types/generics/APIResponse.type";

const NotificationAPI = (queryParams: Record<string, any>) => {
  const queryString = queryParams ? new URLSearchParams(queryParams).toString() : "";
  return !queryString ? "/notification?offset=0&limit=1000" : `/notification?${queryString}`;
};

export const useGetNotification = createGetApiHook<APIResponseType<any[]>, {}>(
  NotificationAPI
);

const markAllAsRead = "notification/mark-all-as-read";

export const useAllNotificationRead = createPostApiHook<
  {},
  {},
  APIResponseType<any>
>(markAllAsRead, {
  isFormDataMethod: false,
});
